module.exports = __webpack_public_path__ + "static/media/Embargo on arms export.e3b9ab64.png";